// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.axCzYK {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 6px;
  border: 1px solid transparent;
  border-radius: var(--radius-s, 4px);
  font-family: var(--font-family-base);
  font-size: 10px;
  font-weight: var(--font-weight-regular, 400);
  line-height: 1.2;
  color: var(--text-neutral-dark, #1f1f1f);
  white-space: nowrap;
}

.pD8iJw {
  width: 10px;
  height: 10px;
  flex-shrink: 0;
}

.otWzgb {
  overflow: hidden;
  text-overflow: ellipsis;
}

.Arprj6 {
  background-color: #e6e6e6;
  border-color: #666666;
}

.iVuQzi {
  background-color: #e6f2fe;
  border-color: #1573d3;
}

.QSrVot {
  background-color: #fff6e6;
  border-color: #fea601;
}

.PZqkv1 {
  background-color: #eef8ec;
  border-color: #387c2b;
}

.ZHsLh_ {
  background-color: #fee7e7;
  border-color: #dc0a0a;
}

@media (max-width: 768px) {
  .axCzYK {
    font-size: 10px;
    padding: 3px 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/OrderStatusBadge/OrderStatusBadge.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,mCAAmC;EACnC,oCAAoC;EACpC,eAAe;EACf,4CAA4C;EAC5C,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 6px;\n  border: 1px solid transparent;\n  border-radius: var(--radius-s, 4px);\n  font-family: var(--font-family-base);\n  font-size: 10px;\n  font-weight: var(--font-weight-regular, 400);\n  line-height: 1.2;\n  color: var(--text-neutral-dark, #1f1f1f);\n  white-space: nowrap;\n}\n\n.tagIcon {\n  width: 10px;\n  height: 10px;\n  flex-shrink: 0;\n}\n\n.tagLabel {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.neutral {\n  background-color: #e6e6e6;\n  border-color: #666666;\n}\n\n.info {\n  background-color: #e6f2fe;\n  border-color: #1573d3;\n}\n\n.warning {\n  background-color: #fff6e6;\n  border-color: #fea601;\n}\n\n.success {\n  background-color: #eef8ec;\n  border-color: #387c2b;\n}\n\n.error {\n  background-color: #fee7e7;\n  border-color: #dc0a0a;\n}\n\n@media (max-width: 768px) {\n  .tag {\n    font-size: 10px;\n    padding: 3px 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tag": `axCzYK`,
	"tagIcon": `pD8iJw`,
	"tagLabel": `otWzgb`,
	"neutral": `Arprj6`,
	"info": `iVuQzi`,
	"warning": `QSrVot`,
	"success": `PZqkv1`,
	"error": `ZHsLh_`
};
module.exports = ___CSS_LOADER_EXPORT___;
